import React, { FC } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Header from 'supportAssistant/components/History/Header'
import ChatPreview from 'supportAssistant/components/History/ChatPreview'
import { mediaQueryUp } from 'components/utils/breakpoint'
import ChatPreviewLoadingSkeleton from './ChatPreviewLoadingSkeleton'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: ${rem(60)} auto;
  height: 100%;
  width: 100%;
  min-width: ${rem(232)};
  background-color: ${({ theme }) => theme.palette.neutral.eight};

  ${mediaQueryUp.md} {
    min-width: ${rem(310)};
  }
`

const ChatHistory = styled.div`
  overflow: auto;
  height: 100%;

  &::-webkit-scrollbar {
    display: none;
  }

  &--scroll-container {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
`

interface HistoryProps {
  activeChatId?: string;
  chatsHistory: any[];
  onSelectChat: (chatId: string) => void;
  onNewChat?: () => void;
  toggle?: () => void;
  loadingChatsHistory?: boolean;
}

const History: FC<HistoryProps> = ({
  activeChatId,
  chatsHistory,
  onSelectChat,
  onNewChat,
  toggle,
  loadingChatsHistory,
}) => {
  return (
    <Container>
      <Header toggle={toggle} onNewChatClick={onNewChat} />
      <ChatHistory>
        {loadingChatsHistory && (
          <ChatPreviewLoadingSkeleton />
        )}
        {!loadingChatsHistory && chatsHistory.map(chat => (
          <ChatPreview key={chat.id} onClick={() => onSelectChat(chat)} title={chat.title}
                       chatCreatedAt={chat.createdAt} lastMessageAt={chat.lastMessageAt}
                       isActive={chat.id === activeChatId} agentType={chat.agentType}/>
        ))}
      </ChatHistory>
    </Container>
  )
}

export default History
